module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.loading) ? _c('div', {
    staticClass: "text-center p-50"
  }, [_c('i', {
    staticClass: "fa fa-spin fa-5x fa-spinner"
  })]) : _c('div', {
    staticClass: "block block-bordered"
  }, [_c('div', {
    staticClass: "block-header block-header-default"
  }), _vm._v(" "), _c('div', {
    staticClass: "block-content p-0"
  }, [_c('table', {
    staticClass: "table table-borderless table-striped table-hover"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.orderNotifications), function(orderNotification) {
    return _c('tr', {
      key: orderNotification.id
    }, [_c('td', [_vm._v(" " + _vm._s(orderNotification.amount) + " ")]), _vm._v(" "), _c('td', [_vm._v("  " + _vm._s(orderNotification.notification_text) + " ")]), _vm._v(" "), (orderNotification.settings.brands.length !== 0) ? _c('td', _vm._l((orderNotification.settings.brands), function(brand) {
      return _c('li', {
        key: brand
      }, [_vm._v(_vm._s(brand))])
    }), 0) : _c('td', [_vm._v(" Alles ")]), _vm._v(" "), _c('td', [_c('label', {
      staticClass: "css-control css-control-primary css-checkbox"
    }, [_c('input', {
      staticClass: "css-control-input",
      attrs: {
        "type": "checkbox",
        "readonly": "",
        "disabled": "disabled"
      },
      domProps: {
        "checked": orderNotification.settings.exclude_sale_products
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "css-control-indicator"
    })])]), _vm._v(" "), _c('td', [_c('label', {
      staticClass: "css-control css-control-primary css-checkbox"
    }, [_c('input', {
      staticClass: "css-control-input",
      attrs: {
        "type": "checkbox",
        "readonly": "",
        "disabled": "disabled"
      },
      domProps: {
        "checked": orderNotification.status
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "css-control-indicator"
    })])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "btn-group",
      attrs: {
        "role": "group"
      }
    }, [_c('button', {
      staticClass: "btn btn-sm btn-secondary  ml-3",
      on: {
        "click": function($event) {
          _vm.select(orderNotification)
        }
      }
    }, [_vm._v("Bewerken")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-sm btn-secondary  ml-3",
      on: {
        "click": function($event) {
          _vm.deleteNotification(orderNotification.id)
        }
      }
    }, [_vm._v("Verwijderen")])])])])
  }), 0)])])]), _vm._v(" "), (!_vm.loading) ? _c('button', {
    staticClass: "btn btn-success btn-noborder",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.openEditModal
    }
  }, [_vm._v("\n    Nieuwe order notificatie\n  ")]) : _vm._e(), _vm._v(" "), (_vm.showEditModal) ? _c('order-notification-edit-modal', {
    ref: "editModal",
    attrs: {
      "order-notification": _vm.selected
    },
    on: {
      "close": _vm.refresh
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Totaal")]), _vm._v(" "), _c('th', [_vm._v("Melding tekst")]), _vm._v(" "), _c('th', [_vm._v("Merken")]), _vm._v(" "), _c('th', [_vm._v("Sales uitgesloten")]), _vm._v(" "), _c('th', [_vm._v("Actief")]), _vm._v(" "), _c('th', [_vm._v("Acties")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-64f4f0ce","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/settings/OrderNotificationTab.vue
// module id = 726
// module chunks = 1